import axios, { AxiosError } from 'axios'
import { ActionWithPayload, AppDispatch, RootState } from '../store'

const PROMO_CODES_REQUEST = 'PROMO_CODES_REQUEST'
const PROMO_CODES_SUCCESS = 'PROMO_CODES_SUCCESS'
const PROMO_CODES_ERROR = 'PROMO_CODES_ERROR'
export const PROMO_CODES_RESET = 'PROMO_CODES_RESET'

interface PromoCodesRequestAction {
  type: typeof PROMO_CODES_REQUEST
}

interface PromoCodesSuccessAction {
  type: typeof PROMO_CODES_SUCCESS
  payload: boolean
}

interface PromoCodesErrorAction {
  type: typeof PROMO_CODES_ERROR
  payload: string
}

type PromoCodesActionTypes =
  | PromoCodesRequestAction
  | PromoCodesSuccessAction
  | PromoCodesErrorAction

export const fetchPromoCodes =
  () => async (dispatch: AppDispatch, getState: () => RootState) => {
    try {
      dispatch({
        type: PROMO_CODES_REQUEST,
      })

      const {
        userLogin: { userInfo },
      } = getState()

      const token = (userInfo as User).token

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }

      const { data } = await axios.get(`/api/promoCodes/list/`, config)

      return dispatch({
        type: PROMO_CODES_SUCCESS,
        payload: data,
      })
    } catch (err) {
      const error = err as AxiosError

      return dispatch({
        type: PROMO_CODES_ERROR,
        payload: error.message,
      })
    }
  }

interface InitialState {
  error: string
  loading: boolean
  success: boolean
  promoCodes: PromoCode[]
}

const initialState: InitialState = {
  error: '',
  loading: false,
  success: false,
  promoCodes: [],
}

export const promoCodesReducer = (
  state = initialState,
  action: ActionWithPayload<PromoCodesActionTypes>
) => {
  switch (action.type) {
    case PROMO_CODES_REQUEST:
      return {
        ...state,
        error: '',
        loading: true,
        success: false,
      }
    case PROMO_CODES_SUCCESS:
      return {
        ...state,
        error: '',
        success: true,
        loading: false,
        promoCodes: action.payload,
      }
    case PROMO_CODES_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
        success: false,
      }
    case PROMO_CODES_RESET:
      return {
        ...initialState,
      }
    default:
      return state
  }
}
